var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoloniex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 55,
    viewBox: "0 0 238 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_104)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_104",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 238,
    height: 55
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237.37 0H0.630432V55H237.37V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.9617 38.9886V16.0072H82.0416C86.8577 16.0072 89.5415 19.3153 89.5415 23.2084C89.5415 27.1014 86.8258 30.4095 82.0416 30.4095H75.9861V38.9886H71.9617ZM81.49 19.5558H75.9861V26.8609H81.49C83.7617 26.8609 85.4101 25.4149 85.4101 23.2084C85.4101 21.0019 83.7585 19.5558 81.49 19.5558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.578 15.6268C110.458 15.6268 115.309 20.6573 115.309 27.514C115.309 34.3707 110.458 39.4044 103.578 39.4044C96.6971 39.4044 91.8459 34.3739 91.8459 27.5173C91.8459 20.6604 96.6971 15.6268 103.578 15.6268ZM103.578 19.2112C98.9338 19.2112 95.9733 22.7598 95.9733 27.5173C95.9733 32.2389 98.9338 35.8232 103.578 35.8232C108.189 35.8232 111.181 32.2389 111.181 27.5173C111.181 22.7598 108.187 19.2112 103.578 19.2112Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.193 38.9886V16.0072H123.217V35.44H133.329V38.9886H119.193Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.643 15.6268C153.523 15.6268 158.375 20.6573 158.375 27.514C158.375 34.3707 153.523 39.4044 146.643 39.4044C139.763 39.4044 134.911 34.3739 134.911 27.5173C134.911 20.6604 139.766 15.6268 146.643 15.6268ZM146.643 19.2112C141.999 19.2112 139.039 22.7598 139.039 27.5173C139.039 32.2389 141.999 35.8232 146.643 35.8232C151.252 35.8232 154.247 32.2389 154.247 27.5173C154.247 22.7598 151.252 19.2112 146.643 19.2112Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.26 38.9886L166.292 22.2466V38.9886H162.267V16.0072H166.396L178.127 32.3074V16.0072H182.152V38.9919H178.26V38.9886Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.031 38.9886V16.0072H191.056V38.9919H187.031V38.9886Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.939 38.9886V16.0072H211.659V19.5558H199.963V25.5156H211.422V29.0642H199.963V35.44H211.659V38.9886H195.939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.131 38.9886L224.698 29.9937L218.265 38.9886H213.45L222.05 27.2054L213.966 16.0072H218.781L224.698 24.4497L230.581 16.0072H235.434L227.385 27.1729L235.95 38.9919L231.131 38.9886Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1852 13.7492V27.4983L36.2974 20.6221L24.4095 13.7492L36.2974 6.87297L48.1852 0V13.7492Z",
    fill: "#20392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.406 27.5013V41.2506L12.5182 34.3743L0.630432 27.5013L12.5182 20.6253L24.406 13.749V27.5013Z",
    fill: "#005C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.630432 13.7487V-0.000488281L12.5182 6.87573L24.406 13.752L12.5182 20.625L0.630432 27.5011V13.7487Z",
    fill: "#3AB06A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.630432 41.2506V27.5013L12.5182 34.3776L24.406 41.2539L12.5182 48.13L0.630432 54.9997V41.2506Z",
    fill: "#20392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2974 20.6253L24.4095 13.749V27.4982V41.2473L36.2974 48.1236L48.1852 54.9999V41.2506V27.5013L36.2974 20.6253Z",
    fill: "#3AB06A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 236.739,
    height: 55,
    fill: "white",
    transform: "translate(0.630432)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoloniex);
export default __webpack_public_path__ + "static/media/poloniex.99ffe7387eebdfb90526d51de8eb854b.svg";
export { ForwardRef as ReactComponent };